<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <!-- normal listbox -->
<!--    value {{ formProperty.nativename }}: {{ value }} / {{ formProperty.value }}-->
    <q-select :label="getTitle()" @update:model-value="onChange" :multiple="formProperty.valuelistPicMax>1" :use-chips="formProperty.cssClass && formProperty.cssClass.includes('use-chips')"
              :placeholder="formProperty.infoTextHint" :readonly="formProperty.readonly || readOnly || loading" :loading="loading"
              v-model="value" map-options :class="formProperty.cssClass" :max-values="formProperty.valuelistPicMax"
              :options="selectOptions" option-value="acr_key" option-label="acr_title" emit-value
              bottom-slots :error="formProperty.errorMsg!==''" :error-message="formProperty.errorMsg" filled :hint="getHint()"
              :input-debounce="formProperty.autocompleteKeylatency" clearable :dense="volatile || compressed" :options-dense="volatile || compressed"
              :id="formProperty.nativename" :ref="formProperty.nativename"
              use-input @filter="filterFn">
      <template #option="scope">
        <q-item v-bind="scope.itemProps" v-on="scope.itemProps">
          <q-item-section avatar v-if="scope.opt.acr_fonticon">
            <q-icon color="primary" :name="scope.opt.acr_fonticon"/>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ scope.opt.acr_title }}</q-item-label>
            <q-item-label caption>{{ scope.opt.acr_subtitle }}</q-item-label>
          </q-item-section>
          <q-item-section side v-if="scope.opt.acr_applytext0 || scope.opt.acr_applytext1">
            <div>
              <q-btn outline dense size="md" v-if="scope.opt.acr_applytext0" :label="scope.opt.acr_applytext0" text-color="primary" @click.stop="dynamicButton(scope.opt, 0)"/>
              <q-btn outline dense size="md" v-if="scope.opt.acr_applytext1" :label="scope.opt.acr_applytext1" text-color="primary" @click.stop="dynamicButton(scope.opt, 1)" class="q-ml-sm"/>
            </div>
          </q-item-section>
        </q-item>
      </template>
      <template v-slot:append v-if="formProperty.ocrType>0">
        <q-btn color="primary" dense flat :icon="formProperty.ocrType === 1 ? 'ion-barcode' : 'ion-qr-scanner'" @click.stop.prevent="showOCRDlg()"/>
      </template>
    </q-select>
  </div>
</template>
<script>
import {getValueOrCleanNull} from './formsHelper'

import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import {useFormularStore} from 'src/stores/FormularStore.js'
import {useAuthStore} from 'src/stores/AuthStore.js'
import FormularHelper from "src/classes/FormularHelper";

export default {
  name: "fldAutocomplete",
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'compressed',
    'readOnly'
  ],
  data() {
    return {
      StaticData,
      value: [],
      selectOptions: this.formProperty.selectOptions ? this.formProperty.selectOptions : [],
      loading: false,
      typingBuffer: ''
    }
  },
  watch: {
    value: function () {
      if (this.value instanceof Array) this.formProperty.value = this.value.join(";")
      else this.formProperty.value = this.value
    },
  },
  methods: {
    showOCRDlg() {
      this.$emit('useOCRScanDialog', {
        formProperty: this.formProperty
      })
    },

    onChange(value) {
      this.formProperty.errorMsg = ""
      this.value = value
      this.formProperty.value = value
      this.setErrorBrandColor()
      this.typingBuffer = null
      this.formProperty.invalid = false

      if (value == null) {
        this.value = []
        this.formProperty.value = ""
      }

      let onChangeValue = this.value instanceof Array ? this.formProperty.value = this.value.join(";") : this.value

      this.$emit('onChange', {
        classID: this.formProperty.classID,
        id: this.formProperty.ID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: onChangeValue
      })

      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }

      if (this.volatile && (this.formProperty.instantRefresh || this.formProperty.instantRefresh === undefined)) {
        this.$emit('onEnter')  // submit volatile parameters for immediate refresh
      }
    },


    async getValue() {
      let result = this.formProperty.value
      const authStore = useAuthStore()

      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]
      //console.warn("use stored value!:", storedValue)

      if (deepLinkParamValue) {
        this.formProperty.value = deepLinkParamValue
        result = this.formProperty.value
      } else if (storedValue != null) {
        result = storedValue
        this.formProperty.value = getValueOrCleanNull(storedValue, this.formProperty)
      } else if (!this.formProperty.value && this.formProperty.defaultValue) {
        this.formProperty.value = this.formProperty.defaultValue
        result = this.formProperty.value
      }

      if (result) {
        result = await this.initList(result)
      }

      return result
    },

    async filterFn(val, update, abort) {
      // logger.info("filterFn: val:", val)
      update(async () => {
        if (val !== "" && val.length >= this.formProperty.autocompleteInvokeMinChars) {
          await this.executeAutocompleteQuery(val)
        } else {
          await this.executeAutocompleteQuery("")
        }
      })
    },

    async executeAutocompleteQuery(searchString) {
      const formStore = useFormularStore()
      let fieldKeyValueList = FormularHelper.getKeyValueListOfField(formStore.formularList, this.formProperty)

      try {
        let data = await formStore.executeAutocompleteQuery({
          propertyClassID: this.formProperty.classID,
          queryID: this.queryID,
          objClassID: this.formProperty.formObjectClassID,
          searchString: searchString,
          fieldKeyValueList: fieldKeyValueList,
        })

        let columns = data.sqlColumn
        let rows = data.rows

        // logger.info("found sqlColumn: ", columns)
        this.selectOptions = []

        if (columns && columns.length > 0 && rows && rows.length > 0) {
          if (columns.find(x => x.name = 'acr_key') && columns.find(y => y.name = 'acr_title')) {
            for (let index = 0; index < rows.length && index < 400; index++) {
              let row = rows[index]
              let rowObj = {}

              for (let i = 0; i < columns.length; i++) {
                rowObj[columns[i].title] = row.cell[i]
                // logger.info("map ", columns[i].name, row.cell[i])
              }
              this.selectOptions.push(rowObj)
            }
            this.formProperty.selectOptions = this.selectOptions
          }
        }
      } catch (error) {
        this.eventBus.globalErrorHandling(this.$t('queryExecutionError'), error)
      }
    },

    dynamicButton(opt, btnIndex) {
      if (opt["acr_applymode" + btnIndex] === 1) {
        window.open(opt["acr_applylink" + btnIndex], '_blank')
      } else if (opt["acr_applymode" + btnIndex] === 2) {
        this.eventBus.autocompleteApplyButton(opt["acr_applyfield" + btnIndex + "name"], opt["acr_applyfield" + btnIndex + "value"], this.formProperty.subtypeCount)
      }
    },

    clear() {
      this.value = []
      this.selectOptions = []
      this.formProperty.value = ""
    },

    getErrorLabel() {
      let result = ""
      if (this.formProperty.paramInfoRequired && this.formProperty.paramInfoRequired !== "") {
        result = this.formProperty.paramInfoRequired
      } else {
        result = "Feld muss befüllt werden."
      }
      return result
    },

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))

        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
        // console.error("Error setErrorBrandColor ", this.formProperty.title, e)
      }
    },

    validateStrictFieldValues(value) {
      if (value && this.selectOptions.length > 0) {
        let found = false

        if (typeof value != 'string') {
          return true;
        }
        let compValue = value.toLowerCase().trim()
        this.selectOptions.filter((opt) => {
          if (opt.acr_title.toLowerCase().trim() === compValue || opt.acr_key.toLowerCase().trim() === compValue) found = true
        })

        if (!found && (this.formProperty.defaultValue != value)) {
          // logger.info("error 'not part of list':", this.formProperty.title, ". value = '" + value + "', defaultValue='" + this.formProperty.defaultValue + "', selectOptions=", this.selectOptions)
          this.formProperty.errorMsg = "Ungültige bzw. veraltete Auswahl. Bitte aktuellen Wert aus der Liste wählen."
          this.formProperty.invalid = true
        }
      }
    },

    async onRefreshComp(data) {
      if (this.formProperty.parentFormPointer?.classID == data.parentClassID && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount) &&
        this.formProperty.nativename === data.nativename) {

        if(data.isEventFromParameter && !this.formProperty.isParameter) return

        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value !== undefined && data.value != null) {

          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''

          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename) || ((data.sourceChangedNativename === this.formProperty.nativename) && this.formProperty.ocrType > 0)) {

            // logger.info("!!! onRefreshComp of ", this.formProperty.title + " triggered: ", data.value)
            this.value = await this.initList(data.value)

            if (this.formProperty.ocrType > 0) {
              if (this.selectOptions.length > 1) {
                this.formProperty.errorMsg = "Kein eindeutiger Wert aus der Liste"
                this.formProperty.invalid = true
              } else if (this.selectOptions.length === 0) {
                this.formProperty.errorMsg = "Ungültige Eingabe - kein Wert aus der Liste"
                this.formProperty.invalid = true
              } else {
                this.formProperty.invalid = false
                this.formProperty.errorMsg = ""
              }
            }

            this.$forceUpdate()

            if (this.formProperty.instantRefresh &&
              (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
              let onChangeValue = this.value instanceof Array ? this.formProperty.value = this.value.join(";") : this.value

              await this.$nextTick(() => {
                this.$emit('onChange', {
                  classID: this.formProperty.classID,
                  parentClassID: this.formProperty.parentFormPointer?.classID,
                  id: this.formProperty.ID,
                  nativename: this.formProperty.nativename,
                  deleteDependentFields: true,
                  value: onChangeValue,
                  sourceChangedNativename: data.sourceChangedNativename,
                  cascadeResolved: data.cascadeResolved === true // server already resolved the cascade - no further compValueChange
                })
              })

            } else {
              this.loading = false
            }

          }
        }
      }
    },
    async initList(value) {
      let result = null
      if (this.formProperty.valuelistPicMax > 1 && value && value.includes(";")) {
        let tmpList = []
        let resultLst = value.split(";")
        resultLst.forEach(token => tmpList.push(token))
        result = tmpList

      } else {
        result = value
        if (value === "") result = null
      }

      if (result) {
        if (result instanceof Array) {
          await this.executeAutocompleteQuery("")
        } else {
          await this.executeAutocompleteQuery(value)
        }
      }
      return result
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
    //this.eventBus.off('onChange')
  },

  mounted: async function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    let value = await this.getValue()
    this.value = value

    this.validateStrictFieldValues(value)

    // await this.executeAutocompleteQuery(value)
    // stored value found with sql - so fill value with it (else ac_desc is empty)
    if (this.selectOptions.length === 1) {
      this.value = this.selectOptions[0].acr_key
    }

    this.formProperty.validate = () => {

      // this.formProperty.errorMsg = ""
      this.setErrorBrandColor()

      let value = this.value ? this.value : ""
      if (Object.keys(value).length === 0) value = ""

      if (this.selectOptions.length === 0 && this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY && value === "") {
        this.formProperty.errorMsg = this.getErrorLabel()
        this.formProperty.invalid = true
      } else {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          if (((this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && value === "") && this.formProperty.showThroughDependency === true) {
            this.formProperty.errorMsg = this.getErrorLabel()
            this.formProperty.invalid = true
          } else {
            this.formProperty.invalid = this.formProperty.errorFetchingData !== ""
            this.formProperty.errorMsg = this.formProperty.errorFetchingData
          }
        } else {
          if ((this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && value === "") {
            this.formProperty.errorMsg = this.getErrorLabel()
            this.formProperty.invalid = true
          } else {
            if (!this.formProperty.invalid) this.formProperty.invalid = this.formProperty.errorFetchingData !== ""
            if (!this.formProperty.errorMsg) this.formProperty.errorMsg = this.formProperty.errorFetchingData
          }
        }
        this.validateStrictFieldValues(value)
      }
    }

    this.formProperty.setValid = () => {
      //this.formProperty.errorMsg = ""
      //this.formProperty.invalid = false
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value
      this.value = []
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
    }

    // Trigger initial compValueChange event - so dependent fields can update (only when not preloaded with instances from oiID parameter)
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      //logger.info("onChange for ", this.formProperty.title, ', objInstanceID: ', this.formProperty.objInstanceID)
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        id: this.formProperty.ID,
        nativename: this.formProperty.nativename, deleteDependentFields: false, value: value
      })
    }
  }
}
</script>

<style lang="sass">

</style>
